import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const boundaryCreateOptimizedPendingItemsSelector = (state: AppState) => state.frontendState.mapTools.boundary.boundaryCreateOptimized.pendingItems;
export const useBoundaryCreateOptimizedPendingItemsSelector = () => useSelector(boundaryCreateOptimizedPendingItemsSelector);
